import React from 'react';
import { Plant } from '../types';
import { plantGlyph } from '../utils/plantGlyph';
import './PlantSidebar.css';

type Props = {
  plants: Plant[];
};

export default function PlantSidebar({ plants }: Props) {
  return (
    <aside className="sidebar">
      <h2 className="sidebar__title">🌿 Plant guide</h2>
      <p className="sidebar__hint">Tap any square on the grid to plant</p>
      <ul className="sidebar__list">
        {plants.map(plant => (
          <li key={plant.plantId} className="sidebar__item">
            <span className="sidebar__emoji">{plantGlyph(plant)}</span>
            <div className="sidebar__info">
              <span className="sidebar__name">{plant.name}</span>
              <span
                className="sidebar__family"
                style={{ background: plant.familyColour + '22', color: plant.familyColour }}
              >
                {plant.family}
              </span>
            </div>
            <span className="sidebar__spacing">
              <span className="sidebar__spacing-num">{plant.perSquareFoot}</span>
              <span className="sidebar__spacing-unit">/sqft</span>
            </span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
